import classNames from 'classnames';
import type { CSSProperties, PropsWithChildren, ReactElement } from 'react';
import React from 'react';
import type PropsWithClassname from 'types/props-with-classname';
import { validateString } from 'utils/validate-string';

import styles from './container.module.scss';

interface Props extends PropsWithClassname {
  readonly wide?: boolean;
  readonly full?: boolean;
  readonly style?: CSSProperties;
}

const rootClass = validateString(styles.root);
const wideClass = validateString(styles.wide);
const fullClass = validateString(styles.full);

function Container({
  children,
  className,
  wide = false,
  full = false,
  style,
}: PropsWithChildren<Props>): ReactElement {
  return (
    <div
      className={classNames(rootClass, className, {
        [wideClass]: wide,
        [fullClass]: full,
      })}
      style={style}
    >
      {children}
    </div>
  );
}

export default Container;
